var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 27,
  viewBox: "0 0 25 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 11.0841C1.25 9.92685 1.78427 8.83445 2.69772 8.12399L10.1977 2.29066C11.5519 1.23742 13.4481 1.23742 14.8023 2.29066L22.3023 8.12399C23.2157 8.83445 23.75 9.92685 23.75 11.0841V23C23.75 23.663 23.4866 24.2989 23.0178 24.7678C22.5489 25.2366 21.913 25.5 21.25 25.5H3.75C3.08696 25.5 2.45107 25.2366 1.98223 24.7678C1.51339 24.2989 1.25 23.663 1.25 23V11.0841Z",
  stroke: "white",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 25.5V13H16.25V25.5",
  stroke: "white",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconHome;